import {
  Cents__plus_impl_qsv4s83hvgnvnlu2892 as Cents__plus_impl_qsv4s8,
  Cents__toString_impl_ko5hxm1a9pwstsznn43 as Cents__toString_impl_ko5hxm,
  Cents__hashCode_impl_slsn8n2ym5pwri0ohtt as Cents__hashCode_impl_slsn8n,
  _Cents___init__impl__6gjhxu21pac6t02ivb3 as _Cents___init__impl__6gjhxu,
  Cents1lsbs5l1tlgw as Cents,
  Cents__times_impl_lj4j3i23cyujloetmye as Cents__times_impl_lj4j3i,
  Cents__times_impl_lj4j3iqx8daabo6nal as Cents__times_impl_lj4j3i_0,
  Cents__minus_impl_j8lyu02ourtksxcdmf8 as Cents__minus_impl_j8lyu0,
} from '../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Companion_getInstance3rf6ssn2f6rf5 as Companion_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimeUnit.mjs';
import { plus31cnlckpy77fa as plus } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/YearMonth.mjs';
import { ClosedLocalDateRange6599xgap66zd as ClosedLocalDateRange } from './types.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  DayOfWeek_SATURDAY_getInstance2pwh8d7e3vqkf as DayOfWeek_SATURDAY_getInstance,
  DayOfWeek_SUNDAY_getInstance2wrn9wqlq8qv4 as DayOfWeek_SUNDAY_getInstance,
} from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DayOfWeek.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ID3j2ictjlq95nd as ID } from './careRates.mjs';
import { getValue48kllevslyh6 as getValue } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var EmployerCostMonthClass;
function EmployerCostMonth() {
  if (EmployerCostMonthClass === VOID) {
    class $ {
      constructor(month, weekdays, care, administration, remaining) {
        this.month_1 = month;
        this.weekdays_1 = weekdays;
        this.care_1 = care;
        this.administration_1 = administration;
        this.remaining_1 = remaining;
      }
      get_total_5dhz70_k$() {
        return Cents__plus_impl_qsv4s8(this.care_1, this.administration_1);
      }
      toString() {
        return 'EmployerCostMonth(month=' + this.month_1.toString() + ', weekdays=' + this.weekdays_1 + ', care=' + Cents__toString_impl_ko5hxm(this.care_1) + ', administration=' + Cents__toString_impl_ko5hxm(this.administration_1) + ', remaining=' + Cents__toString_impl_ko5hxm(this.remaining_1) + ')';
      }
      hashCode() {
        var result = this.month_1.hashCode();
        result = imul(result, 31) + this.weekdays_1 | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.care_1) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.administration_1) | 0;
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.remaining_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EmployerCostMonth()))
          return false;
        if (!this.month_1.equals(other.month_1))
          return false;
        if (!(this.weekdays_1 === other.weekdays_1))
          return false;
        if (!(this.care_1 === other.care_1))
          return false;
        if (!(this.administration_1 === other.administration_1))
          return false;
        if (!(this.remaining_1 === other.remaining_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'EmployerCostMonth');
    EmployerCostMonthClass = $;
  }
  return EmployerCostMonthClass;
}
function estimateEmployerCost(committed, employerShare, start, dailyRates, children) {
  var remaining = committed;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(children, 10));
  var index = 0;
  var _iterator__ex2g4s = children.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var month = plus(start, index_0, Companion_getInstance().MONTH_1);
    var tmp0 = new (ClosedLocalDateRange())(month.get_firstDay_u4rr11_k$(), month.get_lastDay_hikhp_k$());
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.count' call
      var tmp;
      if (isInterface(tmp0, Collection())) {
        tmp = tmp0.isEmpty_y1axqb_k$();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$3 = 0;
        break $l$block;
      }
      var count = 0;
      var _iterator__ex2g4s_0 = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s_0.next_20eer_k$();
        if (!element.get_dayOfWeek_3kfgci_k$().equals(DayOfWeek_SATURDAY_getInstance()) && !element.get_dayOfWeek_3kfgci_k$().equals(DayOfWeek_SUNDAY_getInstance())) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$3 = count;
    }
    var weekdays = tmp$ret$3;
    var tmp0_0 = item.get_entries_p20ztl_k$();
    // Inline function 'kotlin.collections.fold' call
    var accumulator = new (Cents())(_Cents___init__impl__6gjhxu(0n));
    var _iterator__ex2g4s_1 = tmp0_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s_1.next_20eer_k$();
      var sum = accumulator.inCents_1;
      // Inline function 'kotlin.collections.component1' call
      var template = element_0.get_key_18j28a_k$().raw_1;
      // Inline function 'kotlin.collections.component2' call
      var count_0 = element_0.get_value_j01efc_k$();
      accumulator = new (Cents())(Cents__plus_impl_qsv4s8(sum, Cents__times_impl_lj4j3i(Cents__times_impl_lj4j3i(getValue(dailyRates, new (ID())(template)).inCents_1, count_0), weekdays)));
    }
    var fullCost = accumulator.inCents_1;
    var care = Cents__times_impl_lj4j3i_0(fullCost, employerShare);
    var administration = Cents__times_impl_lj4j3i_0(care, 0.15);
    remaining = Cents__minus_impl_j8lyu0(remaining, Cents__plus_impl_qsv4s8(care, administration));
    var tmp$ret$2 = new (EmployerCostMonth())(month, weekdays, care, administration, remaining);
    destination.add_utx5q5_k$(tmp$ret$2);
  }
  return destination;
}
//region block: exports
export {
  estimateEmployerCost as estimateEmployerCost22w3x9tgojuhb,
};
//endregion

//# sourceMappingURL=employerCostEstimate.mjs.map
